const PricingArray = [
  {
    title: "Pro ad constituto",
    text: "Ne usu illud albucius abhor reant, partiendo scriptorem mel ne.",
  },
  {
    title: "Eam commodo",
    text: "Ne his fabellas efficiendi. Eum te rebum accusamus, et omnium option.",
  },
  {
    title: "Fabellas efficiendi",
    text: "Maluisset imperdiet ea vel. Justo doctus dissentiet in nec. ",
  },
  {
    title: "Pro ad constituto",
    text: "Ut sea saperet expetendis, in virtute detraxit quo dipiscing efficiendi nam ea.",
  },
];

export default PricingArray;